import NavBar from "./Components/NavBar/NavBar";
import AlbumLists from "./Components/AlbumLists/AlbumLists";
const App = () => {
  return (
    <>
      <NavBar/>
      <AlbumLists/>
    </>
  );
}

export default App;
